<template>
    <vx-expandable-card data-test="qualification-card">
        <template v-slot:content>
            <div class="flex items-center justify-between gap-2 mb-4">
                <span class="text-xl font-extrabold">Qualification</span>
                <vx-button
                    v-if="qualifications.length"
                    @click="detailed = !detailed"
                    size="sm"
                    color="muted-dark"
                    data-test="toggle-carriers"
                >
                    {{ detailed ? 'Summary' : 'All carriers' }}
                </vx-button>
            </div>
            <page-loading v-if="loading"></page-loading>
            <template v-else>
                <kiosk-tcr-qualification-usecase
                    v-if="marketing"
                    :qualification="marketing"
                    :detailed="detailed"
                    data-test="qualification-MARKETING"
                />
                <vx-alert v-else color="slate" :closeable="false" data-test="qualification-missing">
                    MARKETING is not offered for this brand.
                </vx-alert>
                <vx-disclosure v-if="others.length" appearance="boxed" class="mt-4">
                    <template v-slot:header>Other use cases ({{ others.length }})</template>
                    <template v-slot:content>
                        <div class="flex flex-col gap-4">
                            <kiosk-tcr-qualification-usecase
                                v-for="entry in others"
                                :key="entry.usecase"
                                :qualification="entry"
                                :detailed="detailed"
                                :data-test="`qualification-${entry.usecase}`"
                            />
                        </div>
                    </template>
                </vx-disclosure>
            </template>
        </template>
    </vx-expandable-card>
</template>

<script lang="ts" setup>
import { VxAlert, VxButton, VxDisclosure, VxExpandableCard } from '@voxie/frontend-components';
import { computed, ref } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import KioskTcrQualificationUsecase from '~/components/kiosk/kiosk-ten-dlc/registration/KioskTcrQualificationUsecase.vue';
import { useToasted } from '~/composables/useToasted';
import { adminTenDlcRegistrationClient } from '~/services';
import type { TcrUsecaseQualification } from '~/services/adminTenDlcRegistrationClient.types';
import { catchRequestError } from '~/utils/request';

const props = defineProps<{ brandId: string }>();

const toasted = useToasted();
const qualifications = ref<TcrUsecaseQualification[]>([]);
const loading = ref(true);
const detailed = ref(false);

adminTenDlcRegistrationClient
    .getBrandQualification(props.brandId)
    .then((response) => {
        qualifications.value = response.data.data;
    })
    .catch((e) => {
        toasted.error(catchRequestError(e), { sticky: true });
    })
    .finally(() => {
        loading.value = false;
    });

const marketing = computed(() => qualifications.value.find((entry) => 'MARKETING' === entry.usecase));
const others = computed(() => qualifications.value.filter((entry) => 'MARKETING' !== entry.usecase));
</script>
